import React, { useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { MdExpandMore } from "react-icons/md";

import { MdExpandLess } from "react-icons/md";

import { Button, Collapse, ListItem } from "@mui/material";

const styles = {
  item: {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemLeaf: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    // color: "#000000",
    padding: "10px 24px",
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
  },
  buttonLeaf: {
    // color: theme.palette.text.primary,
    // padding: "17px 8px",
    color: '#FFFFFF',
    justifyContent: "flex-start",
    textTransform: "none",
    letterSpacing: 0,
    width: "100%",
    borderLeft: "solid 8px transparent",
    borderRadius: 0,
    fontSize: "13px",
    "& .MuiButton-label": {
      padding: "10px",
    },
    "&:hover": {
      "& .MuiButton-label": {
        color: "#2FF3FF !important",
        background: "rgba(255, 255, 255, 0.1)",
        padding: "10px",
        borderRadius: "9px",
        "& $icon": {
          color: "#2FF3FF !important",
          // color: "00e0b0",
        },
      },
    },
    "&.depth-0": {
   
    },
  },
  icon: {
    display: "flex",
    alignItems: "center",
    color: `#fff !important`,
  },
  title: {
    marginRight: "auto",
  },
  active: {
    "& .MuiButton-label": {
      color: "#2FF3FF",
      background: "rgba(255, 255, 255, 0.1)",
      padding: "10px",
      paddingRight: "120px",
      borderRadius: "9px",
    
      "& $icon": {
        color: "#2FF3FF !important",
        // color: `${theme.palette.text.primary} !important`,
      },
    },
  },
}

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  const [open, setOpen] = useState(openProp);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };

  if (children) {
    return (
      <ListItem
        disableGutters
        key={title}
        {...rest}
      >
        <Button
          sx={styles.button}
          onClick={handleToggle}
        // style={{ color: "#ccc" }}
        >
          {Icon && <Icon sx={styles.icon} size="20" />}
          <span sx={styles.title}>{title}</span>
          {open ? <MdExpandLess /> : <MdExpandMore />}
        </Button>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      disableGutters
      key={title}
      {...rest}
    >
      <Button
        sx={styles.active}
        component={RouterLink}
        exact
        style={style}
        to={href}
      >
        {Icon && <Icon sx={styles.icon} size="20" />}
        <span sx={styles.title}>{title}</span>
        {Info && <Info />}
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
